import { motion } from "framer-motion";
import Model from "../Model";
import video from "../../images/dumpster.mp4";
import Button from "../Button";

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you Sure?",
  subtitle = "Are you sure you want to delete this account?",
}) => {
  return (
    <Model isOpen={isOpen} onClose={onClose}>
      <div className="p-6 text-center max-w-md mx-auto">
        {/* Animated Trash Icon */}
        <motion.div
          animate={{ y: [0, -5, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="text-6xl text-red-400 mb-4 flex justify-center"
        >
          <video src={video} alt="sdcsd" height={80} width={80} />
        </motion.div>

        {/* Title & Subtitle */}
        <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
        <p className="text-sm text-gray-600 mt-2">{subtitle}</p>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <Button
            text=" Yes, Delete It!"
            onClick={onConfirm}
            className="bg-primary text-white px-5 py-2 rounded-md hover:bg-indigo-900 transition"
          ></Button>
          <Button
            text="Cancel"
            onClick={onClose}
            className="bg-red-500 text-white px-5 py-2 rounded-md hover:bg-red-600 transition"
          ></Button>
        </div>
      </div>
    </Model>
  );
};

export default ConfirmDeleteModal;
